import type { WithLoadingIndicatorFunction } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import type { GraphState } from 'components/Graph/GraphState';
import type { GraphCommandContext } from 'components/Graph/model/GraphCommandContext';
import { withCommandModelLoadingIndicator } from 'utils/loading/withCommandModelLoadingIndicator';

export const withGraphsLoadingIndicator = <TResult,>(
  cmdContext: GraphCommandContext,
): WithLoadingIndicatorFunction<TResult> =>
  withCommandModelLoadingIndicator<GraphState, TResult>(cmdContext, 'loading');
